import React, { ReactElement } from 'react'

export const CallStartOutboundIcon = (): ReactElement => (
    <svg viewBox='0 0 100 100'>
        <path
            d='m72.371 16.516-10.512 13.812c-1.5 1.8008-1.2031 3.9023 0 5.4062l7.207 7.207c3.3047 3.0039-19.52 25.824-22.523 22.824l-7.207-7.207c-1.5-1.5-3.9023-1.5-5.4062-0.30078l-13.812 10.512c-1.8008 1.2031-1.8008 3.3047-0.60156 4.8047l8.707 8.4102c9.6094 9.6094 33.934-8.1094 41.441-15.617 7.5078-7.5078 25.227-32.133 15.617-41.742l-8.4102-8.4102c-1.2031-1.5-3.6055-1.2031-4.5039 0.30078zm-22.223 30.332h-21.922v6.0078l-16.215-12.312 16.215-12.312v6.0078h21.922v12.613z'
            fillRule='evenodd'
        />
    </svg>
)
